import React, { RefCallback, useCallback } from 'react';

import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';

const CustomHtml: React.FC<SliceComponentProps<Content.CustomHtmlSlice>> = ({
  slice,
}) => {
  const customHtmlRef: RefCallback<HTMLDivElement> = useCallback(
    (container) => {
      if (!container || !slice.primary.code) {
        return;
      }

      try {
        // <script>'s created using innerHTML will not run, unless SSRed,
        // therefore we need to manually recreate them.
        container.innerHTML = slice.primary.code;

        const scripts = Array.from(container.querySelectorAll('script'));

        for (const script of scripts) {
          const replacement = document.createElement('script');

          for (const attribute of Array.from(script.attributes)) {
            replacement.setAttribute(attribute.name, attribute.value);
          }

          replacement.text = script.text;

          script.parentNode?.replaceChild(replacement, script);
        }
      } catch (e) {
        console.error(`error processing custom html: ${e}`);
      }
    },
    [slice.primary.code]
  );

  return <div ref={customHtmlRef} />;
};

export default CustomHtml;
